import styled from "styled-components"

export const Header = styled.div`
  font-size: ${({ size }) => size || "54px"};
  color: #fff;
`

export const Line = styled.hr`
  width: 60px;
  height: 4px;
  background-color: #fff;
  margin-top: 11px;
  margin-bottom: 34px;
`

export const Contact = styled.div`
  /* padding-top: 63px; */
`

export const ContactText = styled.div`
  @media (max-width: 768px) {
    margin-top: 20px;
    & > p {
      margin-top: 10px;
    }
  }
`

export const ContactIconText = styled.div`
  width: ${({ width }) => (width ? width : "")};
  display: flex;
  margin-bottom: 21px;
  align-items: ${({ start }) => (start ? "" : "center")};
  & span {
    margin-right: 18px;
    color: #5b5b5b;
  }
  & p {
    font-size: 16px;
  }
`

export const ContactForm = styled.div`
  margin-top: 20px;
`

export const YMap = styled.div`
  height: 500px;
`
